import { render, staticRenderFns } from "./CouponsTable.vue?vue&type=template&id=36a2920c&scoped=true&lang=pug&"
import script from "./CouponsTable.vue?vue&type=script&lang=js&"
export * from "./CouponsTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36a2920c",
  null
  
)

export default component.exports